require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/modules/es7.symbol.observable.js
// module id = 526
// module chunks = 0